export default __webpack_public_path__ + "static/media/RedAd.afd78075.jpg";